import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Stack,
  Typography,
} from '@mui/material'
import { FC } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { useModalClosePrevention } from 'src/hooks/useModalClosePrevention'
import { ErrorTemplateRef } from 'src/state/middleware/saga/handleHttpError'

type UsedInTemplateErrorDialogProps = {
  open: boolean
  templates: Array<ErrorTemplateRef>
  onClose: () => void
}

/**
 * マスタ項目定義がひな形で使用されている場合のエラーダイアログ
 *
 * 使用中のひな形名をリンク付きで一覧表示する。
 */
export const UsedInTemplateErrorDialog: FC<UsedInTemplateErrorDialogProps> = ({
  open,
  templates,
  onClose,
}) => {
  const handleDialogClose = useModalClosePrevention(onClose)
  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      maxWidth="sm"
      aria-labelledby="used-in-template-error-dialog-title"
    >
      <DialogTitle
        id="used-in-template-error-dialog-title"
        sx={{ borderBottom: 1, borderColor: 'divider' }}
      >
        下記のひな形に使用されているため、この項目は削除できません。削除するにはひな形から項目を削除してください。
      </DialogTitle>
      <DialogContent>
        <Typography variant="subtitle2" sx={{ fontSize: '16px', mt: 2, mb: 1 }}>
          この項目が使用されているひな形
        </Typography>
        <Stack spacing={1} sx={{ maxHeight: 288, overflow: 'auto' }}>
          {templates.map(template => (
            <Link
              key={template.id}
              component={RouterLink}
              to={`/templates/${template.id}/pages/edit`}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ wordBreak: 'break-word' }}
            >
              {template.name}
            </Link>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions
        sx={{
          borderTop: 1,
          borderColor: 'divider',
          backgroundColor: 'grey.100',
        }}
      >
        <Stack direction="row" spacing={2}>
          <Button variant="contained" color="secondary" onClick={onClose}>
            閉じる
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  )
}
